<template>
  <div v-if="modelValue" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="fixed inset-0 bg-black/50" @click="$emit('update:modelValue', false)"></div>
    <div class="relative min-h-screen flex items-center justify-center p-4">
      <div class="relative bg-white rounded-xl shadow-2xl overflow-hidden max-w-2xl w-full">
        <div class="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
          <h3 class="text-lg font-semibold text-slate-900">{{ title }}</h3>
          <button
            type="button"
            class="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
            aria-label="关闭"
            @click="$emit('update:modelValue', false)"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6">
          <div class="mb-4">
            <h4 class="text-lg font-semibold text-slate-800">{{ currentMessage?.title || '消息通知' }}</h4>
            <p class="text-sm text-slate-500 mt-1">{{ currentMessage?.time }}</p>
          </div>
          <div
            v-if="currentMessage?.contentHtml"
            class="prose prose-sm max-w-none"
            v-html="currentMessage.contentHtml"
          ></div>
          <p v-else class="text-sm leading-6 text-slate-600 whitespace-pre-wrap">{{ currentMessage?.content || '暂无内容' }}</p>
        </div>
        <div class="px-6 py-4 border-t border-slate-200 flex justify-end gap-3">
          <button
            v-if="currentMessage && showNavigation"
            type="button"
            class="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm hover:bg-primary-700 transition-colors"
            @click="$emit('navigate', message)"
          >
            查看
          </button>
          <button
            type="button"
            class="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors"
            @click="$emit('update:modelValue', false)"
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  message: {
    type: Object,
    default: null
  },
  showNavigation: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '消息详情'
  }
})

defineEmits(['update:modelValue', 'navigate'])

const currentMessage = computed(() => props.message)
</script>
